import { Reducer } from 'redux';
import { getDateOneDayBeforeTodayHourZero, getDateTodayHourZero } from '../../Utils/Time';

import { IEmissionSearchFilters, IPlayerActionTypes, IPlayerGroups, IPlayerRapidSearchFilters, IPlayerState, IAdvancedSearchPlayerFilters } from './Types';

let endDate = getDateOneDayBeforeTodayHourZero(getDateTodayHourZero())
let initialState: IPlayerState = {
    playerRapidList: {
        broadcasts: [], 
        summary: []
    },
    playerAdvancedList: {
        broadcasts: [], 
        summary: []
    },
    broadcasts: [],
    summary: [],
    isLoading: false,
    tableLabel: 'Tous les partis',
    startDate: new Date(endDate.getFullYear(), endDate.getMonth(), 1),
    endDate: endDate,
    playerGroups: [],
    initialPlayerGroupsID: [],
    initialPlayerGroupsStr: [],
    playerPersons: [],
    initialPlayerPersonsID: [],
    initialPlayerPersonsStr: [],
    advancedSearchPlayerFilters: null,
    emissions: [],
    emissionSearchFilters: null,
    emissionSearchResults: null,
    currentSearch: 'rapid',
    playerRapidSearchFilters: null,
    mediaID: -1,
    expiresAt: -1,
    fingerprintID: undefined,
    videoPlayerEndDate: -1,
    videoPlayerStartDate: -1,
    isPlayerGroupsLoading: false,
    isEmissionAutocompleteLoading: false,
    isPlayerPersonsLoading: false
}

const reducer: Reducer<IPlayerState> = (state = initialState, action) => {
    switch (action.type) {
        case IPlayerActionTypes.GET_PLAYER_RAPID_SEARCH: {
            let filters:IPlayerRapidSearchFilters = action.payload
            if (action.payload !== null) {
                return {
                    ...state,
                    isLoading: true,
                    playerRapidSearchFilters: filters,
                    advancedSearchPlayerFilters: null,
                    startDate: filters.start_date,
                    endDate: filters.end_date,
                    tableLabel: filters.person_name,
                    broadcasts: [],
                    summary: [],
                    currentSearch: 'rapid'
                };
            }
            return {
                ...state
            }
        }
        case IPlayerActionTypes.GET_PLAYER_RAPID_SEARCH_SUCCESS: {
            if (action.payload !== null ) {
                return {
                    ...state,
                    broadcasts: action.payload.broadcasts,
                    summary: action.payload.summary,
                    isLoading: false
                }
            }
            return{
                ...state
            }
        }
        case IPlayerActionTypes.GET_PLAYER_RAPID_SEARCH_ERROR: {
            return{
                ...state,
                isLoading: false
            }
        }
        case IPlayerActionTypes.GET_PLAYER_GROUPS: {
            return {
                ...state,
                playerPersons: [],
                initialPlayerPersonsID: [],
                initialPlayerPersonsStr: [],
                isPlayerGroupsLoading: true
            }
        }
        case IPlayerActionTypes.GET_PLAYER_GROUPS_SUCCESS: {
            let groups:any = []
            let groupsID:number[] = []
            let groupsStr:string[] = []

            if (action.payload.length > 0) {
                groups = action.payload
                groupsID = groups.map((x:IPlayerGroups)=>{
                    return x.id
                })
                groupsStr = groups.map((x:IPlayerGroups)=>{
                    return x.name
                })
            }
            return {
                ...state,
                playerGroups: groups,
                initialPlayerGroupsID: groupsID,
                initialPlayerGroupsStr: groupsStr,
                isPlayerGroupsLoading: false
            }
        }
        case IPlayerActionTypes.GET_PLAYER_PERSONS: {
            return {
                ...state,
                isPlayerPersonsLoading: true
            }
        }
        case IPlayerActionTypes.GET_PLAYER_PERSONS_SUCCESS: {
            let persons = action.payload
            if (persons.length !== undefined && persons.length > 0) {
                let personsID:number[] = persons.map((x:IPlayerGroups)=>{
                    return x.id
                })
                let personsStr:string[] = persons.map((x:IPlayerGroups)=>{
                    return x.name
                })
                return {
                    ...state,
                    playerPersons: action.payload,
                    initialPlayerPersonsID: personsID,
                    initialPlayerPersonsStr: personsStr,
                    isPlayerPersonsLoading: false
                }
            } else {
                return {
                    ...state,
                    playerPersons: [],
                    initialPlayerPersonsID: [],
                    initialPlayerPersonsStr: [],
                    isPlayerPersonsLoading: false
                }
            }
            
        }
        case IPlayerActionTypes.GET_PLAYER_ADVANCED_SEARCH: {
            let filters:IAdvancedSearchPlayerFilters = action.payload
            let label:string = "Tous les partis"
            if (filters.political_group_name !== undefined) {
                label = filters.political_group_name
            }
            if (filters.person_name !== undefined) {
                label = filters.person_name
            }
            return {
                ...state,
                isLoading: true,
                advancedSearchPlayerFilters: filters,
                startDate: filters.start_date,
                endDate: filters.end_date,
                playerRapidSearchFilters: null,
                emissionSearchFilters: null,
                tableLabel: label,
                broadcasts: [],
                summary: [],
                currentSearch: 'advanced'
            };
        }
        case IPlayerActionTypes.GET_PLAYER_ADVANCED_SEARCH_SUCCESS: {
            if (action.payload !== null ) {
                return {
                    ...state,
                    broadcasts: action.payload.broadcasts,
                    summary: action.payload.summary,
                    isLoading: false
                }
            }
            return{
                ...state
            }
        }
        case IPlayerActionTypes.GET_PLAYER_ADVANCED_SEARCH_ERROR: {
            return{
                ...state,
                isLoading: false,
                broadcasts: []
            }
        }
        case IPlayerActionTypes.RESET_DATA: {
            let newState = {...state}
            newState = initialState
            return newState
        }
        case IPlayerActionTypes.GET_EMISSION_AUTOCOMPLETE: {
            return {
                ...state,
                isEmissionAutocompleteLoading: true
            }
        }
        case IPlayerActionTypes.GET_EMISSION_AUTOCOMPLETE_SUCCESS: {
            return {
                ...state,
                emissions: action.payload,
                isEmissionAutocompleteLoading: false
            }
        }
        case IPlayerActionTypes.CLEAR_EMISSION_LIST: {
            return {
                ...state,
                isEmissionAutocompleteLoading: false,
                emissions: []
            }
        }
        case IPlayerActionTypes.GET_EMISSION_SEARCH: {
            let filters: IEmissionSearchFilters = action.payload[0]
            if (filters !== null) {
                return {
                    ...state,
                    emissionSearchFilters: filters,
                    playerRapidSearchFilters: null,
                    advancedSearchPlayerFilters: null,
                    tableLabel: action.payload[1],
                    startDate: filters.date_start,
                    endDate: filters.date_end,
                    broadcasts: [],
                    summary: [],
                    isLoading: true,
                    currentSearch: 'emission'
                }
            }
            return state
            
        }
        case IPlayerActionTypes.GET_EMISSION_SEARCH_SUCCESS: {
            if (action.payload !== null ) {
                return {
                    ...state,
                    broadcasts: action.payload.broadcasts,
                    summary: action.payload.summary,
                    isLoading: false
                }
            }
            return{
                ...state
            }
        }
        case IPlayerActionTypes.GET_EMISSION_SEARCH_ERROR: {
            return{
                ...state,
                isLoading: false,
                broadcasts: []
            }
        }
        case IPlayerActionTypes.SAVE_VIDEO_PLAYER_PARAMS: {
            return {
                ...state,
                mediaID: action.payload[0],
                videoPlayerStartDate: action.payload[1],
                videoPlayerEndDate: action.payload[2],
                expiresAt: action.payload[3],
                fingerprintID: action.payload[4]
            }
        }
        default: {
            return state;
        }
    }
};

export { reducer as PlayerReducer };
